import { CoreApi } from '@inter-ikea-storageone/range';
import { PanelArrangement } from '@inter-ikea-storageone/range-pax';
import { CustomizedSlidingDoorComponent } from '@inter-ikea-storageone/range-pax';
import computePanelArrangement from './computePanelArrangement';
import { Entity } from '@inter-ikea-core/core';

const getPanelArrangement: (doorEntity: Entity, coreApi: CoreApi) => PanelArrangement = (
  doorEntity,
  coreApi
) => {
  if (doorEntity.hasComponent(CustomizedSlidingDoorComponent.id)) {
    return doorEntity.getComponent<CustomizedSlidingDoorComponent>(
      CustomizedSlidingDoorComponent.id
    )!.panelArrangement;
  }
  return computePanelArrangement(doorEntity, coreApi);
};

export default getPanelArrangement;
